import React, { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './favorite.css';
import { Skeleton } from 'primereact/skeleton';
import ProductImage from '../../assets/images/product/product.svg';
import Hearth from '../../assets/icons/hearth.svg';
import HeartBold from '../../assets/icons/heart-bold.svg';
import { getFavoriteList, addBasket, getBasketList, deleteBasket, getDiscountProduct, deleteFavorite } from '../../utils/api';
import Trash from '../../assets/icons/trash.svg';
import { Dialog } from 'primereact/dialog';
import { OverlayPanel } from 'primereact/overlaypanel';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import Loader from '../loader/dotloader'
import { useCart } from '../../contexts/CartContext';
import useToastNotification from '../../hooks/useToastNotification';
import ThreeLoader from '../loader/threeDots'



export default function ProductsSlider({ productCat }) {
    const [products, setProducts] = useState([]);
    const [discountList, setDiscountList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [addToBasket, setaddToBasket] = useState(true);
    const [basketList, setBasketList] = useState({});
    const [visible, setVisible] = useState(false); // Dialog visibility state
    const [product, setproduct] = useState({}); // Dialog content state
    const [autoplay, setAutoplay] = useState(true); // کنترل وضعیت autoplay
    const [selectedDiscount, setSelectedDiscount] = useState(null);
    const { addToCart } = useCart();
    const [loadingQuantities, setLoadingQuantities] = useState({});
    const typingTimers = useRef({});

    const { showError, showSuccess } = useToastNotification();

    const overlayRef = useRef(null);
    const [show, setShow] = useState(false);
    // داخل کامپوننت:
    const refs = useRef({}); // یک آبجکت برای ذخیره refs به صورت داینامیک

    const ref = useRef(null); // برای container اصلی Overlay

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShow(false); // تابعی که overlay رو می‌بنده
            }
        };

        if (show) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [show]);

    const getRef = (id) => {
        if (!refs.current[id]) {
            refs.current[id] = React.createRef();
        }
        return refs.current[id];
    };
    const fetchProductData = async () => {
        const basketData = await fetchBasketList();
        await fetchProducts(basketData);

    };

    const getTotalPrice = (price, product) => {
        let totalPrice = parseInt(product.count) * parseInt(price)
        return totalPrice.toLocaleString()
    }
    useEffect(() => {

        fetchProductData();
    }, []);

    const fetchBasketList = async () => {
        try {
            // setLoading(true)
            const res = await getBasketList(JSON.parse(localStorage.getItem('userInfo')).si);
            const basketData = res.data.reduce((acc, item) => {
                acc[item.Id_Kala] = {
                    count: item.Nq,      // تعداد محصول در سبد خرید
                    basketId: item.Si // شناسه سبد خرید برای حذف یا ویرایش
                };
                return acc;
            }, {});
            setBasketList(basketData);
            return basketData;
        } catch (error) {
            console.error('Error fetching basket:', error);
            return {};
        } finally {
            setLoading(false)
        }
    };

    const fetchProducts = async (basketData) => {
        try {

            let productsData = await getFavoriteList(JSON.parse(localStorage.getItem('userInfo')).si)
            const updatedProducts = productsData.data.map(product => ({
                ...product,
                count: basketData[product.Id_Kala]?.count || 0,
                BasketId: basketData[product.Id_Kala]?.basketId || ''
            }));

            const enrichedData = [];
            for (const item of updatedProducts) {
                const discountRes = await getDiscountProduct(item.Id_Kala);
                enrichedData.push({
                    ...item,
                    discounts: discountRes.data,
                });
            }
            setProducts(enrichedData);

        } catch (error) {

        }


    };

    const fetchDiscountProduct = async (id) => {
        try {
            setShow(false); // مخفی کردن اولیه
            setSelectedDiscount(null); // پاک کردن مقدار قبلی برای جلوگیری از کش شدن

            const res = await getDiscountProduct(id);
            if (res.data.length > 0) {
                setTimeout(() => {
                    setSelectedDiscount({ id, discounts: res.data });
                    setShow(true); // نمایش تخفیف جدید
                }, 100); // تاخیر کوتاه برای اطمینان از به‌روز شدن مقدار
            } else {
                setSelectedDiscount(null);
                setShow(false);
            }
        } catch (error) {
            console.error('Error fetching discount:', error);
        }
    };


    useEffect(() => {
    }, [selectedDiscount])



    const handleAddToBasket = async (product, event) => {
        if (!JSON.parse(localStorage.getItem('userInfo'))) {
            window.location.hash = 'login';
            return;
        }
        setSelectedDiscount([])
        await fetchDiscountProduct(product.Id_Kala);
        const newCount = product.MinOrder;
        setProducts(products.map(p =>
            p.Id_Kala === product.Id_Kala ? { ...p, count: newCount } : p
        ));
        setproduct(prev => ({ ...prev, count: newCount }));
        try {
            let res = await addBasket({
                id: product.Id_Kala,
                count: newCount,
                userId: JSON.parse(localStorage.getItem('userInfo')).si
            });
            if (res.status == 200) {
                showSuccess(`${product.KalaName} به سبد خرید اضافه شد.`)
                addToCart();

                let basketData = await fetchBasketList()
                setProducts(products.map(p =>
                    p.Id_Kala === product.Id_Kala ? { ...p, BasketId: basketData[product.Id_Kala]?.basketId, count: newCount } : p
                ));
                setproduct(prev => ({ ...prev, BasketId: basketData[product.Id_Kala]?.basketId }));

                setBasketList(prev => ({
                    ...prev,
                    [product.Id_Kala]: newCount
                }));
            }


        } catch (error) {
            console.error('Error adding to basket:', error);
        }
    };

    const handleIncrease = async (product, event) => {
        const newCount = product.count + 1;
        setInputValues((prevValues) => ({
            ...prevValues,
            [product.Si]: newCount,
        }));

        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            let res = await addBasket({
                id: product.Id_Kala,
                count: newCount,
                userId: JSON.parse(localStorage.getItem('userInfo')).si
            });
            if (res.status == 200) {
                setTimeout(() => {
                    showSuccess(`${parseInt(newCount)} عدد ${product.KalaName} در سبد خرید شما وجود دارد.`)
                    setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));

                }, 1000);
                setProducts(products.map(p =>
                    p.Si === product.Si ? { ...p, count: newCount } : p
                ));
                addToCart()
            }

        } catch (error) {
            console.error('Error increasing product count:', error);
        }
    };

    const handleDecrease = async (product, event) => {
        const newCount = product.count - 1;


        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            if (newCount >= product.MinOrder) {
                let res = await addBasket({
                    id: product.Id_Kala,
                    count: newCount,
                    userId: JSON.parse(localStorage.getItem('userInfo')).si
                });
                if (res.status == 200) {
                    setInputValues((prevValues) => ({
                        ...prevValues,
                        [product.Si]: newCount,
                    }));

                    setProducts(products.map(p =>
                        p.Si === product.Si ? { ...p, count: newCount } : p
                    ));
                    setTimeout(() => {
                        showSuccess(`${parseInt(newCount)} عدد ${product.KalaName} در سبد خرید شما وجود دارد.`)
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));

                    }, 1000);

                }
            } else {
                let res = await deleteBasket({
                    userId: JSON.parse(localStorage.getItem('userInfo')).si,
                    id: product.BasketId
                });
                if (res.status == 200) {
                    setProducts(products.map(p =>
                        p.Si === product.Si ? { ...p, count: 0 } : p
                    ));
                    setTimeout(() => {
                        showSuccess(`${product.KalaName} از سبد خرید حذف شد.`)
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));

                    }, 1000);
                    //    addToCart();
                }


            }


        } catch (error) {
            console.error('Error decreasing product count:', error);
        }
    };

    const openDialog = (product) => {
        const updatedProduct = products.find(p => p.Si === product.Si);
        setproduct(updatedProduct || product);
        setVisible(true);
        setAutoplay(false);
    };

    const handleDialogIncrease = async () => {
        const newCount = product.count + 1;


        try {
            await addBasket({
                id: product.Id_Kala,
                count: newCount,
                userId: JSON.parse(localStorage.getItem('userInfo')).si
            });
            setInputValues((prevValues) => ({
                ...prevValues,
                [product.Id_Kala]: newCount,
            }));
            setproduct(prev => ({ ...prev, count: newCount }));
            setProducts(products.map(p => p.Id_Kala === product.Id_Kala ? { ...p, count: newCount } : p));
            // setproduct(prev => ({ ...prev, count: newCount }));

            // setProducts(products.map(p =>
            //   p.Si === product.Si ? { ...p, count: newCount } : p
            // ));
        } catch (error) {
            console.error('Error increasing product count in dialog:', error);
        }
    };

    const handleDialogDecrease = async () => {
        const newCount = product.count - 1;

        // همگام‌سازی مقدار در دیالوگ و لیست محصولات
        setproduct(prev => ({ ...prev, count: newCount }));

        try {
            if (newCount >= product.MinOrder) {
                await addBasket({
                    id: product.Id_Kala,
                    count: newCount,
                    userId: JSON.parse(localStorage.getItem('userInfo')).si
                });
                setInputValues((prevValues) => ({
                    ...prevValues,
                    [product.Id_Kala]: newCount,
                }));

                setproduct(prev => ({ ...prev, count: newCount }));

                setProducts(products.map(p =>
                    p.Id_Kala === product.Id_Kala ? { ...p, count: newCount } : p
                ));
            } else {
                await deleteBasket({
                    userId: JSON.parse(localStorage.getItem('userInfo')).si,
                    id: product.BasketId
                });
                addToCart();
                setproduct(prev => ({ ...prev, count: newCount }));

                setProducts(products.map(p =>
                    p.Id_Kala === product.Id_Kala ? { ...p, count: 0 } : p
                ));
            }
        } catch (error) {
            console.error('Error decreasing product count in dialog:', error);
        }
    };



    const handleDialogClose = () => {
        setVisible(false);
        setproduct({});
    };


    const handleDialogInputChange = (value) => {
        const newCount = parseInt(value) || 0;
        if (newCount >= product.MinOrder) {
            setproduct(prev => ({ ...prev, count: newCount }));
        }
    };



    const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول

    const handleMouseDownslid = () => setIsScrolling(false);
    const handleMouseMoveslid = () => setIsScrolling(true);
    const handleMouseUpslid = (product) => {
        if (!isScrolling) {
            openDialog(product);
        }
    }
    const checkDiscount = (product, count) => {
        console.log('...............', product, count)
        if (!product?.discounts?.length) return;

        for (const item of product.discounts) {
            const nq = item.Nq;
            if (nq) {
                if (nq.includes("از") && nq.includes("تا")) {
                    const match = nq.match(/از\s*(\d+)\s*تا\s*(\d+)/);
                    if (match) {
                        const from = parseInt(match[1]);
                        const to = parseInt(match[2]);
                        if (count >= from && count <= to) {
                            setProducts(prevItems =>
                                prevItems.map(p =>
                                    p.Si === product.Si ? { ...p, discountPrice: item.Price, SumInvoice: (item.Price * count) } : p
                                )
                            );
                            break;
                        }
                    }
                } else if (nq.includes("بیشتراز")) {
                    const match = nq.match(/بیشتراز\s*(\d+)/);
                    if (match) {
                        const from = parseInt(match[1]);
                        if (count > from) {
                            setProducts(prevItems =>
                                prevItems.map(p =>
                                    p.Si === product.Si ? { ...p, discountPrice: item.Price, SumInvoice: (item.Price * count) } : p
                                )
                            );
                            break;
                        }
                    }
                }
            }
        }
    };

    const deleteFromFavorite = async (product) => {
        try {
            let pay = {
                UserId: JSON.parse(localStorage.getItem('userInfo')).si,
                productId: product.Id_Kala
            }
            let res = await deleteFavorite(pay)
            if (res.data == 'OK') {
                // حذف محصول از لیست محصولات (بدون نیاز به رفرش صفحه)
                setProducts(prevProducts => prevProducts.filter(p => p.Si !== product.Si));
            }
        } catch (error) {
            console.error('Error deleting from favorite:', error);
        }
    }
    const prevItemsRef = useRef([]); // ذخیره مقدار قبلی items

    useEffect(() => {
        // اگر items تغییر کرده و قبلاً مقدارش با مقدار جدید متفاوت است، چک کنیم
        if (JSON.stringify(prevItemsRef.current) !== JSON.stringify(products)) {
            products.forEach(item => {
                checkDiscount(item, item.count); // چک کردن تخفیف برای هر محصول
            });
            prevItemsRef.current = products; // به‌روز رسانی مقدار قبلی items
        }
    }, [products]); // فقط وقتی items تغییر کرد اجرا شود
    const [inputValues, setInputValues] = useState({});

    const handleUpdateBasket = async (newCount, product) => {

        try {
            setLoadingQuantities(prev => ({ ...prev, [product.Si]: true }));
            if (newCount >= product.MinOrder) {
                let res = await addBasket({ id: product.Id_Kala, count: newCount, userId: JSON.parse(localStorage.getItem('userInfo')).si });
                if (res.status == 200) {
                    setTimeout(() => {
                        setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                        checkDiscount(product, newCount)
                    }, 2000);
                    setProducts(products.map(p =>
                        p.Si === product.Si ? { ...p, count: newCount } : p
                    ));
                }

            } else {
                let res = await deleteBasket({
                    userId: JSON.parse(localStorage.getItem('userInfo')).si,
                    id: product.BasketId
                });
                if (res.status == 200) {
                    setLoadingQuantities(prev => ({ ...prev, [product.Si]: false }));
                    setProducts(products.map(p =>
                        p.Si === product.Si ? { ...p, count: 0 } : p
                    ));
                }

            }
        } catch (error) {
            console.error('Error updating basket:', error);
        }
    };
    const findProductBySi = (si) => {
        return products.find((p) => p.Si.toString() === si.toString());
    };
    const handleInputChange = (product, value) => {
        const si = product.Si.toString();
        const numericValue = value.replace(/\D/g, '');

        setInputValues(prev => ({
            ...prev,
            [si]: numericValue,
        }));

        // اگر تایمر قبلی وجود داره، حذف کن
        if (typingTimers.current[si]) {
            clearTimeout(typingTimers.current[si]);
        }

        // شروع تایمر جدید
        typingTimers.current[si] = setTimeout(() => {
            const productObj = findProductBySi(si);
            const parsed = parseInt(numericValue, 10);
            const finalCount = isNaN(parsed) || parsed < productObj.MinOrder ? productObj.MinOrder : parsed;

            setInputValues(prev => ({
                ...prev,
                [si]: finalCount.toString(),
            }));

            handleUpdateBasket(finalCount, productObj);

            // حذف تایمر پس از پایان
            delete typingTimers.current[si];
        }, 1200); // 1.2 ثانیه تأخیر
    };

    const handleBlur = (product) => {
        let finalValue = parseInt(inputValues[product.Id_Kala] || '0', 10); // از مقدار مخصوص همان محصول استفاده کنیم

        if (!finalValue || finalValue < product.MinOrder) {
            finalValue = product.MinOrder;
        }

        setInputValues((prevValues) => ({
            ...prevValues,
            [product.Id_Kala]: finalValue.toString(),
        }));
        handleUpdateBasket(finalValue, product); // مقدار نهایی را به سبد خرید ارسال کنیم
    };

    function convertToPersianNumbers(input) {
        if (input) {

            const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
    }
    return (
        <>


            <div className='profile-card'>
                <h6 className='page-title mb-4 mt-3'>علاقه مندی ها</h6>
                {loading ? (<div className='mt-4'>

                    <div className="skeleton-wrapper gy-3 row web-selekton">
                        {[...Array(6)].map((_, index) => (
                            <div className='col-12 col-md-6'>
                                <div className='product-item d-flex  gap-3 flex-col-ipad' >
                                    <div className='product-img aspect-[4/4]'>
                                        <Skeleton className='img-product h-100' alt="Image 1" />
                                    </div>
                                    <div className='detail-text'>
                                        <div className='detail w-50 '>
                                            <Skeleton className='mt-1' />
                                            <Skeleton className='mt-4 number-font' width='100px' />
                                            <Skeleton className='mt-2 number-font' width='120px' />
                                            <Skeleton className='mt-2 number-font' width='140px' />
                                        </div>

                                        <div className='d-flex align-items-center gap-2 mt-4'>
                                            <Skeleton height='40px' width='40px' className='btn btn-primary  h-[48px]' />
                                            <Skeleton height='40px' width='40px' />
                                            <Skeleton height='40px' width='40px' className='btn btn-primary  h-[48px]' />
                                            {/* )} */}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="skeleton-wrapper container row gy-3  mobile-selekton px-0">
                        {[...Array(6)].map((_, index) => (
                            <div className='col-12 col-md-6 col-lg-6'>
                                <div className='product-item d-flex  gap-3 flex-col-ipad' >
                                    <div className='product-img aspect-[4/4]'>
                                        <Skeleton className='img-product h-100 aspect-[4/4]' alt="Image 1" />
                                    </div>
                                    <div className='detail-text'>
                                        <div className='detail w-50 '>
                                            <Skeleton className='mt-1' />
                                            <Skeleton className='mt-4 number-font' width='100px' />
                                            <Skeleton className='mt-2 number-font' width='120px' />
                                            <Skeleton className='mt-2 number-font' width='140px' />
                                        </div>

                                        <div className='d-flex align-items-center gap-2 mt-4'>
                                            <Skeleton height='32px' width='32px' className='btn btn-primary  h-[48px]' />
                                            <Skeleton height='32px' width='32px' />
                                            <Skeleton height='32px' width='32px' className='btn btn-primary  h-[48px]' />
                                            {/* )} */}
                                        </div>

                                    </div>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>) : (
                    <>
                        {products.length > 0 ? (
                            <div className='row mx-auto gy-3'>
                                <>
                                </>
                                {
                                    products.length > 0 && products.map((product, index) => (
                                        <div className='col-12 col-md-6'>
                                            <div className='product-item d-flex gap-3 flex-col-ipad'
                                            >

                                                <div className='product-img aspect-[4/4]'>
                                                    <img src={product.Pic_A} className='img-box img-product' alt={product.KalaName} />
                                                    <img src={HeartBold} className='favorite-icon' alt="" onClick={() => deleteFromFavorite(product)} />
                                                </div>
                                                <div className='detail-text'>
                                                    <div className='detail'>
                                                        <h4 className='font-semibold'>{convertToPersianNumbers(product.KalaName)}</h4>
                                                        <div className='d-flex align-items-center gap-3 justify-content-between'>
                                                            <h5 className={`${(product.discountPrice && product.Price != product.discountPrice) ? 'discount-price' : ''} mt-2 number-font`}>{parseInt(product.Price).toLocaleString()} تومان</h5>
                                                            {(product.discountPrice && product.Price != product.discountPrice) && (

                                                                <h5 className='mt-2 number-font'>{parseInt(product.discountPrice).toLocaleString()} تومان</h5>
                                                            )}
                                                        </div>                                                {/* <h6 className='text-sm d-flex align-items-center mb-0' style={{ color: '#242526', direction: 'rtl', fontSize: '10px' }}>قیمت کل : {parseInt(product.SumPrice).toLocaleString()} تومان</h6> */}
                                                    </div>

                                                    <span className='f-10'>حداقل تعداد خرید محصول {convertToPersianNumbers((product.MinOrder).toString())} عدد</span>
                                                    <div ref={getRef(product.Si)}>
                                                        {product.count >= product.MinOrder ? (
                                                            <div>
                                                                <div className='text-center w-100 d-flex justify-content-start'>
                                                                    <div className='d-flex align-items-center justify-content-center mt-4 gap-2 increas w-fit' ref={getRef(product.Si)}>
                                                                        <button className='btn btn-primary ' style={{ width: '40px', height: '40px', fontSize: '10px' }} onClick={() => handleIncrease(product)} >+</button>
                                                                        {loadingQuantities[product.Si] ? (
                                                                            <div className='form-control  text-center d-flex align-items-center justify-content-center' style={{ width: '48px', height: '40px' }}>
                                                                                <ThreeLoader />

                                                                            </div>
                                                                        ) : (
                                                                            <input
                                                                                className={`form-control text-center number-font `}
                                                                                style={{ height: '40px', width: '40px' }}
                                                                                value={inputValues[product.Si] ?? product.count}
                                                                                onChange={(e) => handleInputChange(product, e.target.value)}
                                                                                onMouseEnter={async () => {
                                                                                    setSelectedDiscount(null)
                                                                                    await fetchDiscountProduct(product.Id_Kala)
                                                                                }}
                                                                            />
                                                                        )}



                                                                        <button ref={getRef(product.Si)} className='btn btn-primary w-[32px] d-flex align-items-center justify-center' style={{ width: '40px', height: '40px' }} onClick={() => handleDecrease(product)}>
                                                                            {product.count === product.MinOrder ? <img src={Trash} width={18} /> : '-'}
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                {selectedDiscount?.id === product.Id_Kala && selectedDiscount?.discounts.length > 0 && (
                                                                    <div ref={ref}>
                                                                        <Overlay
                                                                            target={getRef(product.Si).current}
                                                                            show={show && selectedDiscount?.id === product.Id_Kala}
                                                                            placement="left"
                                                                        >
                                                                            {(props) => (
                                                                                <Tooltip id="overlay-example" {...props}>
                                                                                    <div className="discount-list">
                                                                                        {selectedDiscount.discounts.map((discount, index) => (
                                                                                            <div key={index} className="discount-item">
                                                                                                <span className="number-font">{discount.Nq ?? ''}</span>
                                                                                                <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </Tooltip>
                                                                            )}
                                                                        </Overlay>
                                                                    </div>

                                                                )}
                                                            </div>

                                                        ) : (
                                                            <button className='mt-3 btn btn-primary w-[150px]' onClick={(e) => handleAddToBasket(product, e)}>افزودن</button>
                                                        )}
                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    ))
                                }
                            </div>
                        ) : (
                            <>
                                هیچ محصولی در علاقه مندی های شما وجود ندارد.

                            </>
                        )}
                    </>
                )}

            </div>
            <Dialog
                draggable={false}
                dismissableMask
                visible={visible}
                style={{ width: '30vw' }}
                breakpoints={{ '600px': '400vw', '500px': '100vw' }}
                onHide={handleDialogClose}
                className="custom-dialog"
            >
                <div className='product-item'>
                    <div className='product-img mx-auto'>
                        <img src={product.Pic_A} className='img-box img-product' alt={product.KalaName} />
                        <img src={Hearth} className='favorite-icon' alt="" />
                    </div>
                    <div className='detail'>
                        <h4 className='mt-4'>{product.KalaName}</h4>
                        <span className='text-sm'>توضیحات محصول: {product.Tp}</span>
                        <div className='d-flex align-items-center justify-content-center gap-3 mt-2'>
                            <span className='text-[12px] item' >کد کالا: {product.Code}</span>
                            <span className='text-[12px] item' >گروه کالا: {product.GrpName}</span>
                        </div>
                        <h5 className='mt-2'>{parseInt(product.Price).toLocaleString()} تومان</h5>
                        <span className='text-[12px] item'>حداقل تعداد خرید محصول {product.MinOrder} عدد</span>
                    </div>
                    {product.count >= product.MinOrder ? (
                        <div className='d-flex align-items-center justify-content-center mt-4 gap-2 increas'>
                            <button className='btn btn-primary w-[48px]' onClick={handleDialogIncrease}>+</button>
                            <input
                                className='form-control w-[48px] h-[48px] text-center'
                                style={{ height: '48px' }}
                                value={inputValues[product.Id_Kala] ? inputValues[product.Id_Kala] : product.count}
                                onChange={(e) => handleInputChange(product, e.target.value)}
                                onBlur={() => handleBlur(product)}
                            />
                            <button className='btn btn-primary w-[48px] d-flex align-items-center justify-center' onClick={handleDialogDecrease}>
                                {product.count === product.MinOrder ? <img src={Trash} /> : '-'}
                            </button>
                        </div>
                    ) : (
                        <button className='mt-3 btn btn-primary w-100' onClick={() => handleAddToBasket(product, e)}>افزودن</button>
                    )}
                </div>
            </Dialog>


        </>
    );
}
